import { render, staticRenderFns } from "./BetaContent.vue?vue&type=template&id=ab3c404c&scoped=true"
import script from "./BetaContent.vue?vue&type=script&lang=js"
export * from "./BetaContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3c404c",
  null
  
)

export default component.exports